import { useCallback } from 'react'

import { audioManager } from '@/utils/audio'

export type SoundType = 'success' | 'error'

interface AudioOptions {
  volume?: number
  playbackRate?: number
}

export const useAudio = () => {
  // 直接使用全局 audioManager，避免重复实现
  const playSound = useCallback((type: SoundType, options: AudioOptions = {}) => {
    audioManager.play(type, options.volume)
  }, [])

  const playSuccess = useCallback((options?: AudioOptions) => {
    audioManager.playSuccess(options?.volume)
  }, [])

  const playError = useCallback((options?: AudioOptions) => {
    audioManager.playError(options?.volume)
  }, [])

  const preloadAllSounds = useCallback(() => {
    audioManager.preloadAll()
  }, [])

  return {
    playSound,
    playSuccess,
    playError,
    preloadAllSounds
  }
}